export { default } from "./CollapsibleTranscript";
